import React, { useCallback } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import useTilt from "../hooks/useTilt";

const CertCard1 = ({ cert, index }) => {
  const [scrollRef, isVisible] = useScrollReveal({ delay: index * 120 });
  const tilt = useTilt(5);
  const mergedRef = useCallback(
    (node) => {
      scrollRef(node);
      tilt.ref.current = node;
    },
    [scrollRef, tilt.ref]
  );

  return (
    <div
      ref={mergedRef}
      className={`columns portfolio-item ${isVisible ? "reveal-visible" : "reveal"}`}
      onMouseMove={tilt.handleMove}
      onMouseLeave={tilt.handleLeave}
    >
      <h3>{cert.title}</h3>
      <div className="item-wrap">
        <div className="card-glare" />
        <div className="card-shine" />
        <a href={cert.url} title={cert.title} target="_blank" rel="noopener noreferrer">
          <img alt={cert.title} src={cert.image} />
          <div className="overlay">
            <div className="portfolio-item-meta">
              <h5>{cert.title}</h5>
              <p>{cert.category}</p>
            </div>
          </div>
          <div className="link-icon">
            <i className="fa fa-link">&nbsp;Credentials</i>
          </div>
        </a>
      </div>
    </div>
  );
};

const Portfolio = ({ data }) => {
  if (!data) return null;

  return (
    <section id="certificate">
      <section id="portfolio" className="cert-continuation">
        <div className="row">
          <div className="columns collapsed">
            <div
              id="portfolio-wrapper"
              className="bgrid-quarters s-bgrid-thirds cf"
            >
              {data.certifications.map((cert, i) => (
                <CertCard1 key={cert.title} cert={cert} index={i} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Portfolio;
